const n = {
  name: "ExternalLinkSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.58579 15.9998L13.5858 8.99985H9V6.99985H17V14.9998H15V10.4141L8 17.4141L6.58579 15.9998Z" fill="currentColor"/>
</svg>
  `
};
export {
  n as ExternalLinkSmall
};
